import { render } from "./MSSubmissionsPanel.vue?vue&type=template&id=e5a0a458&scoped=true&ts=true"
import script from "./MSSubmissionsPanel.vue?vue&type=script&lang=ts"
export * from "./MSSubmissionsPanel.vue?vue&type=script&lang=ts"

import "./MSSubmissionsPanel.vue?vue&type=style&index=0&id=e5a0a458&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5a0a458"]])

export default __exports__